<template>
    <div class="tsa-rightsInfo">
        <div class="title">
            <p>申请信息</p>
        </div>
        <div class="info">
            <div class="item">
                <div class="name">
                    <p>申请人</p>
                </div>
                <p class="value">{{ result.applicant }}</p>
            </div>
            <div class="item">
                <div class="name">
                    <p>权利人</p>
                </div>
                <p class="value">{{ result.owner }}</p>
            </div>
            <div class="item desc">
                <div class="name">
                    <p>申请人自述声明</p>
                </div>
                <p class="value">{{ result.applicantDeclaration }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        result: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data () {
        return {
        }
    },
}
</script>

<style lang="scss" scoped>
    @import './css/mobile.scss';
</style>